import tippy from 'tippy.js';

const initFlatCard = (parent: HTMLElement): void => {
    if (!parent) {
        throw Error(`Parent is ${parent}`);
    }

    const selectors = {
        attrTooltipsInited: 'data-tippy-inited'
    };

    const tooltipsEl = [].slice.call(parent.querySelectorAll('.flat-card-icons-tooltips__icon'));

    if (tooltipsEl?.length) {
        if (parent.hasAttribute(selectors.attrTooltipsInited)) {
            return;
        }

        tippy(tooltipsEl, {
            arrow    : false,
            theme    : 'flat-card',
            placement: 'bottom',
            offset   : [0, -10],
            content(ref) {
                if ('alt' in ref) {
                    return (ref as HTMLImageElement).alt;
                }

                return '';
            },
            onCreate: () => {
                parent.setAttribute(selectors.attrTooltipsInited, '');
            }
        });
    }
};

export default initFlatCard;
